module.exports = __webpack_public_path__ + "img/empty-state.957619ff.png";